import axios from 'axios';
import * as GetParams from "@/assets/js/get_params.js";
import * as Sender from "@/assets/js/sender.js";

var key;
var token;

var client = axios.create({
	baseURL: process.env.VUE_APP_API_BASE_URL,
});

var entry = function (phone, host) {
	return client.post('/client/authorization/entry', {
		phone: phone,
		host: host
	}).then(response => {
		key = response.data.key;
		token = response.data.token;
		return response.data;
	});
};

var confirm = function (code) {
	return client.post('/client/authorization/confirm', {
		key: key,
		token: token,
		code: code
	}).then(response => {
		if (response.data.bearer) {
			localStorage.setItem('token', response.data.bearer);
		}
		return response.data;
	});
};

var logout = function () {
	var config = { headers: { 'Authorization': 'Bearer ' + getToken() } };
	localStorage.removeItem('token');
	return client.post('/client/authorization/logout', {}, config);
};

var getToken = function () {
	return localStorage.getItem('token');
};

var setTokenFromQuery = function () {
	let url = new URL(location.href);
	const params = new URLSearchParams(url.search);
	let token = params.get("bearer");
	window.bid = {
		id: params.get("bidId")
	}

	if (token) {
		localStorage.setItem('token', token);
	}
};

var load = function (endpoint, data) {
	if (typeof data === 'undefined') {
		data = {};
	}
	var config = { headers: { 'Authorization': 'Bearer ' + getToken() } };
	return client.post(endpoint, data, config).then(response => response.data);
};

var oauth2 = function (client) {
	const host = location.hostname.replace("lk.", "")
	const redirect_url = `https://lk.${host}/showcase`
	const amount = GetParams.get('amount')
	const period = GetParams.get('period')
	const host_type = 'anketa'
	const consent = true
	const geoByIp = true

	window.location = buildConnectUrl(process.env.VUE_APP_API_BASE_URL + `/oauth2/client/${client}/connect`, {
		host,
		redirect_url,
		host_type,
		amount,
		period,
		consent,
		geoByIp
	});
};

function buildConnectUrl(baseUrl, inputQuery) {
	const BASE_KEYS = new Set([
		// белый список “базовых” параметров, которые должны остаться плоскими
		'host', 'redirect_url', 'host_type', 'amount', 'period', 'consent', 'geoByIp'
	]);

	const subs = Sender.getSubs();
	const utms = Sender.getUtms();

	// Собираем финальный URL
	const u = new URL(baseUrl);

	// Добавляем базовые параметры (из inputQuery) в плоском виде
	for (const k of BASE_KEYS) {
		if (k in inputQuery && inputQuery[k] != null && String(inputQuery[k]) !== '') {
			u.searchParams.set(k, String(inputQuery[k]));
		}
	}

	// Добавляем subs[...]=...
	Object.entries(subs).forEach(([sk, sv]) => {
		u.searchParams.append(`subs[${sk}]`, sv);
	});
	Object.entries(utms).forEach(([sk, sv]) => {
		u.searchParams.append(`utm[${sk}]`, sv);
	});

	return u.toString();
}

export { entry, confirm, logout, getToken, load, setTokenFromQuery, oauth2 }
